module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('site-header'), _vm._v(" "), _c('div', {}, [_c('div', {
    staticClass: " px-6 py-2 md:p-6 bg-gray-100"
  }, [_c('header', {
    staticClass: "mb-3"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "my-1"
  }, [_c('button', {
    staticClass: "block text-left bg-gray-100 w-full p-1 text-xs text-gray",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.push('/create')
      }
    }
  }, [_vm._v("\n              ← Create a new list\n            ")])])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    staticClass: "block w-full border border-gray bg-white p-2 mb-2",
    attrs: {
      "type": "search",
      "placeholder": "Search cities or spots..."
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.lists) ? _c('div', _vm._l((_vm.lists), function(list) {
    return _c('div', {
      key: list._id
    }, [(_vm.shouldShow(list)) ? _c('div', {
      staticClass: "py-3"
    }, [_c('h3', [_c('strong', [_c('a', {
      staticClass: "text-blue-400 hover:text-blue-700",
      attrs: {
        "href": list.slug
      }
    }, [_vm._v(_vm._s(list.name))])])]), _vm._v(" "), (list.description) ? _c('p', {
      staticClass: "text-gray-700 font-bold text-sm",
      domProps: {
        "textContent": _vm._s(list.description)
      }
    }) : _vm._e(), _vm._v(" "), _c('p', {
      staticClass: "text-gray text-sm"
    }, _vm._l((list.ideas), function(idea, index) {
      return _c('span', [(index !== 0) ? _c('span', [_vm._v(", ")]) : _vm._e(), _vm._v(" "), (idea && ('name' in idea)) ? _c('span', [_vm._v(_vm._s(idea.name))]) : _vm._e()])
    }), 0)]) : _vm._e()])
  }), 0) : _vm._e()])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("All the Best Spots")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cb784dd4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/AllPage.vue
// module id = 162
// module chunks = 1